import { Dropdown, DropdownProps } from 'primereact/dropdown';

import { useGetPredictionTechsQuery } from '@/app/services/equipment';

import './EquipmentDropdown.css';

type EquipmentDropdownProps = DropdownProps & {
  className?: string;
  label?: string;
};

export const EquipmentDropdown = ({
  className,
  label,
  ...dropdownProps
}: EquipmentDropdownProps) => {
  const { data: techsData } = useGetPredictionTechsQuery({
    where: {
      or: [{ farmlocation: { eq: false } }, { farmlocation: { eq: null } }],
    },
  });

  const options = techsData?.map((tech) => ({
    value: tech.id,
    label: tech.name,
  }));

  return (
    <div
      className={`equipment-dropdown${label ? 'label-input-group' : ''} ${className}`.trim()}
    >
      {label && <label>{label}</label>}
      <Dropdown
        appendTo="self"
        options={options}
        filter
        filterPlaceholder="Search"
        filterInputAutoFocus={true}
        {...dropdownProps}
      />
    </div>
  );
};
